module.exports = __webpack_public_path__ + "static/media/icons-full-screen-select.7530c8c7.svg";